import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/invoices/${number | ':invoiceId'}/sendManualReminder`;

export const ROUTE: RouteDefinition = `${baseRoute}/invoices/:invoiceId/sendManualReminder`;

export const URL = (invoiceId: number): RouteDefinition => `${baseRoute}/invoices/${invoiceId}/sendManualReminder`;
